import React, { useState, useEffect } from 'react';
import './App.css';
import Project from './Main/Project/Project';
import Nav from './Main/Nav/Nav';
import Home from './Main/Home/Home';
import Achievement from './Main/Achievement/Achievement';
import Contacts from './Main/Contacts/Contacts';

function App() {

  const [alldata, setAlldata] = useState([]);
  useEffect(() => {
    fetch('https://script.google.com/macros/s/AKfycbxp_GP4SXvQT-62-GV06PvocDiiQ7tdBVuX4rS6qM277ALnI65-3Mpg6YcC4uNQ3ER5rg/exec')
      .then(res => res.json())
      .then(data => {
        console.log(data); // Log the fetched data
        setAlldata(data);  // Set the state with the fetched data
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }, []);

  if (!alldata.length) {
    return <div className='loading'>Loading...</div>; // Show loading state until data is fetched
  }
  // console.log(alldata[0].project1_img);

  const projectdata = [
    {projectimg : alldata[0].project1_img,
    projectName : alldata[0].project1_name,
    projectDescription : alldata[0].project1_desp,
    projectLink : alldata[0].project1_link
    },
    {
      projectimg : alldata[0].project2_img,
    projectName : alldata[0].project2_name,
    projectDescription : alldata[0].project2_desp,
    projectLink : alldata[0].project2_link
    },
    {
      projectimg : alldata[0].project3_img,
    projectName : alldata[0].project3_name,
    projectDescription : alldata[0].project3_desp,
    projectLink : alldata[0].project3_link
    }
  ]
  const certificatedata = [
    {projectimg : alldata[0].cert1_img,
    projectName : alldata[0].cert1_name,
    projectDescription : alldata[0].cert1_desp,
    projectLink : alldata[0].cert1_link
    },
    {
      projectimg : alldata[0].cert2_img,
    projectName : alldata[0].cert2_name,
    projectDescription : alldata[0].cert2_desp,
    projectLink : alldata[0].cert2_link
    },
    {
      projectimg : alldata[0].cert3_img,
    projectName : alldata[0].cert3_name,
    projectDescription : alldata[0].cert3_desp,
    projectLink : alldata[0].cert3_link
    }
  ]
  return (
    <div className="App">
      <Nav alldata = {alldata}/>
      <Home alldata = {alldata} />
      <Achievement alldata = {alldata} />
      <Project heading = {"Project"} data = {projectdata} />
      <Project heading = {"Certificates"} data = {certificatedata} />
      <Contacts alldata = {alldata}/>
    </div>
  );
}

export default App;
